var v1="<span ng-if=\"!editMode\">{{ score.shot_cnt }}</span><span ng-if=\"editMode\" class=\"column-input\"><span ng-change=\"valueUpdated(score, 'shot_cnt')\" gnp-custom-select=\"\" ng-model=\"score.shot_cnt\" display-property=\"value\" options=\"score.scoreOptions\" class=\"input {{score.shot_cnt ? score.shotCntColor : 'normal'}} shot\"></span></span>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/shot.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/score-card/templates/shot.jade
// module id = 405
// module chunks = 0